import React from 'react';
import { demoSiteUrl } from '@/config/demo';

type DemoLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

// Anchor to the public demo. Resolves to the demo.statharbour.com subdomain on
// the production marketing site and to the in-app /demo route everywhere else
// (see demoSiteUrl). It renders a real <a> because the target can be a
// cross-origin subdomain, which react-router's <Link> cannot express.
const DemoLink: React.FC<DemoLinkProps> = ({ children, ...props }) => (
  <a href={demoSiteUrl()} {...props}>
    {children}
  </a>
);

export default DemoLink;
